/* eslint-disable no-console */
import Vue from 'vue'
import Vuex from 'vuex'
import {apiGet} from './dal'


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    newTransactions : [],
    expectedTransactions : [],
    categories : [],
    rules:[],
    lastMonthsTransactions :[],
    thisMonthsTransactions :[],
    dashTransactions:[],
    dataInit : false,
    topCategoryAmounts:[],
    lastImport : null,
  },
  mutations: {
    addCategory(state,data){      
      state.categories.push(data);
    },
    addRule(state,data){
      // insert rule at the beginning of the array
      state.rules.unshift(data);      
    },
    setExpectedTransactions(state,data){
      state.expectedTransactions = data;
    },    
    setDashTransactions(state,data){
      state.dashTransactions = data;
    },
    setDataInit(state,data){
      state.dataInit = data;
    },
    setLastMonthsTransactions(state,data){
      state.lastMonthsTransactions = data;
    },
    setLastImport(state,dateTime){
      state.lastImport = dateTime;
    },
    setRules(state,data){
      state.rules = data;
    },
    setNewTransactions(state,data){
      state.newTransactions = data;
    },
    setCategories(state,data){
      state.categories = data;
    },
    setThisMonthsTransactions(state,data){
      state.thisMonthsTransactions = data;
    },
    setTopCategoryAmounts(state,data){
      state.topCategoryAmounts = data;
    },
    removeNewTransaction(state,data){
      let idx = state.newTransactions.findIndex(item=>{
        return item.TRA_ID == data.TRA_ID;
      });
      if(idx >= 0){
        state.newTransactions.splice(idx,1);
      } else{
        console.log('Transaction id '+data.TRA_ID+' not found');
      }
    },
    removeRule(state,data){
      let idx = state.rules.findIndex(item=>{
        return item.RULE_ID == data.RULE_ID;
      });
      if(idx >= 0){
        state.rules.splice(idx,1);
      } else{
        console.log('Rule id '+data.RULE_ID+' not found');
      }
    },

    updateNewTransaction(state,data){
      let idx = state.newTransactions.findIndex(item=>{
        return item.TRA_ID == data.TRA_ID;
      });
      if(idx >= 0){
        state.newTransactions.splice(idx,1,data);
      } else{
        console.log('Transaction id '+data.TRA_ID+' not found');
      }
    },
    
    updateRule(state,data){
      let idx = state.rules.findIndex(item=>{
        return item.RULE_ID == data.RULE_ID;
      });
      if(idx >= 0){
        state.rules.splice(idx,1,data);
      } else{
        state.rules.push(data);
      }
    },
  },
  actions: {
    getNewTransactions({commit}){
      apiGet('last-import').then(data=>{
        commit('setLastImport',data);
      });
      apiGet('db/new-transactions').then(data=>{    
          data.map(t=>{
            t.rule = null;
            t.noRuleMatch=null;
            t.TRA_CAT_ID = null
          })
          commit('setNewTransactions', data);
      })
    },

    getExpectedTransactions({commit}) {
      apiGet("expected-transactions").then((data) => {
         commit('setExpectedTransactions', data);
      });
   },
    
    getCategories({commit}){
      apiGet('categories').then(data=>{
        data.map(item=>{
          item.fullName = getHoleName(item.CAT_ID,data);
        });
        commit('setCategories', data);
     })
    },

    getThisMonthsTransactions({commit}){
      let date = new Date();
      apiGet('db/last-transactions/'+date.getFullYear()+'/'+(date.getMonth()+1)).then(data=>{
        commit('setThisMonthsTransactions', data);
     })
    },

    getLastMonthsTransactions({commit}){
      let date = new Date();
      let month = date.getMonth();
      let year = date.getFullYear();
      if(month == 0){
        year = year-1;
        month = 12;
      }
      apiGet('db/last-transactions/'+year+'/'+month).then(data=>{
        commit('setLastMonthsTransactions', data);
     })
    },

    getRules({commit}){
      apiGet('rules').then(data=>{
        commit('setRules', data);
     })
    },


    
  }
})


let getHoleName = function(catId,categories){
  let result = ""
  
  for (let index = 0; index < categories.length; index++) {
      const element =  categories[index];
       if(element.CAT_ID == catId){
           if(element.CAT_PARENT_ID){
               return getHoleName(element.CAT_PARENT_ID,categories)+"."+element.CAT_NAME;
           } else{
              return  element.CAT_NAME;
           }
          
      }
  }                 
  return result;
}